export const mapSurveyTypeToRoute = ({
  description,
  help_url,
  hierarchy_search_prompts,
  id,
  isSpecialty,
  name,
  prompts,
}) => ({
  description,
  help_url,
  id,
  isSpecialty,
  label: name,
  path: id,
  prompts,
  searchPrompts: hierarchy_search_prompts,
});

export const SURVEY_TABS = [
  {
    id: 'instant-surveys',
    label: 'Surveys',
    path: 'instant-surveys',
    target: 'package.instant_surveys',
    type: 'survey',
  },
  {
    id: 'survey-lab',
    label: 'Survey Labs',
    path: 'survey-lab',
    target: 'package.survey_lab',
    type: 'survey',
  },
];
